module.exports = __webpack_public_path__ + "static/media/15_agrorural_mobile.c01637da.jpg";